import useReveal from "@/hooks/useReveal";

export default function Reveal({ children, delay = 0, as: As = "div", className = "" }) {
  const { ref, visible } = useReveal();
  return (
    <As
      ref={ref}
      style={{ transitionDelay: visible ? `${delay}ms` : "0ms" }}
      className={`transition-all duration-700 ease-out ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"} ${className}`}
    >
      {children}
    </As>
  );
}
